export const alertTypes = {
  actionRequired: 'ACTION_REQUIRED',
  updateNeeded: 'UPDATE_NEEDED',
  waitingValidation: 'WAITING_VALIDATION',
  none: 'NONE',
  resolved: 'RESOLVED',
};
